import "./style.css";
import { ReactComponent as Logo } from 'ressources/icons/logo.svg';

import { useTranslation, Trans } from "react-i18next";

export default () => {

  const { t, i18n } = useTranslation();

    const links = [
        {name: t('presentation'), div: "section-main-landing"},
        {name: t('partners'), div: "partners-landing"},

    ]

    const scrollIntoDiv = (div) => {
        document.getElementsByClassName(div)[0].scrollIntoView({ behavior: "smooth" });
    }

  return (
    <div id="landing-shortbar" className="landing-shortbar">
      <div className="landing-shortbar-logo">
        <Logo className="landing-shortbar-logo-svg"/>
      </div>
      <div className="landing-shortbar-links">
          {links.map(link => (
              <div onClick={() => scrollIntoDiv(link.div)} className="landing-shortbar-link">{link.name}</div>
          ))}
      </div>
    </div>
  );
};
